import { type ApiError } from '@resolute/schema';

/**
 * Normalised client-side error carrying the API's code + message. Kept in
 * its own dependency-free module, separate from `api-client.ts` (which
 * instantiates axios at module scope) — `query-client.ts` needs this class
 * for its retry logic but is imported eagerly at app root, so importing it
 * from `api-client.ts` would have pulled axios into the main bundle for
 * every visitor, even though the actual API client is only ever used inside
 * lazy-loaded route pages.
 */
export class RequestError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status?: number,
    public readonly details?: ApiError['error']['details'],
  ) {
    super(message);
    this.name = 'RequestError';
  }
}
